import { Lock } from "lucide-react";
import type { ReactNode } from "react";

export function ScimNotice({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-start gap-2.5 rounded-lg border border-muted p-3 text-sm text-foreground/70">
      <Lock
        className="mt-0.5 h-3.5 w-3.5 shrink-0"
        strokeWidth={2}
        aria-hidden="true"
      />
      <p>{children}</p>
    </div>
  );
}
